import React, {Component} from 'react';
import routes from '../helpers/exportRoutes';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import Main from "../modules/main";
import Game from "../modules/game/Game";
import Developers from "../modules/developers";

class Router extends Component {
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path={routes.landing} component={Main}/>
          <Route exact path={routes.game} component={Game}/>
          <Route exact path={routes.dev} component={Developers}/>
        </Switch>
      </BrowserRouter>
    );
  }
}

export default Router;
